
import { supabase } from '@/lib/supabase';

export async function updateUserActivity(organizationId: string): Promise<boolean> {
  try {
    if (!organizationId) {
      console.warn('Impossible de mettre à jour l\'activité: ID d\'organisation manquant');
      return false;
    }

    const { error } = await supabase.rpc(
      'update_user_activity',
      { p_organization_id: organizationId }
    );

    if (error) {
      console.error('Erreur lors de la mise à jour de l\'activité:', error);
      // Ne pas afficher d'erreur à l'utilisateur car c'est une opération en arrière-plan
      return false;
    }

    return true;
  } catch (error) {
    console.error('Exception lors de la mise à jour de l\'activité:', error);
    return false;
  }
}

